import styled from 'styled-components';

import { token, spaceMixin, IconCheckmarkCircleOutline } from '@zillow/constellation';

export const StyledContainer = styled.div`
    background-color: ${token('colors.blue200')};
    padding: ${spaceMixin('lg')};
`;

export const StyledIcon = styled(IconCheckmarkCircleOutline)`
    && {
        color: ${token('colors.brand')};
        height: 100px;
        width: 100px;
        margin-bottom: ${spaceMixin('xs')};
    }
`;

export const StyledCenterContainer = styled.div`
    text-align: center;
`;
